import React from 'react'
// para poder hacer los links de mi Nabbar
import {
    Link,
    NavLink
} from 'react-router-dom'
// auth de firebase para cerrar sesion
import { auth } from '../firebase'
// para redirigir al usuario debemos usar el withRouter
import { withRouter } from 'react-router-dom'



// utulizo mi props
const Navbar = (props) => {

    // hago mi metodo para cerrar sesion
    const cerrarSesion = () => {

        // para ello llamo auth de firebase para poder usar el metodo que nos brinda para cerrar sesion
        // cierro la sesion activa
        auth.signOut()
            // .then() --> que es la respuesta de exito, empujamos al usuario al login
            .then(() => {
                // mi withRouter -> me puede acceder al mi history que me ayuda a empujar al usuario a la ruta que deseo
                props.history.push('/login')
            })
    }



    return (
        // Creo el navbar con sus clases
        <div className="navbar navbar-dark bg-dark">
            {/* Creo el hook para poder hacer referencias a mis paginas */}
            <Link
                // que redirija a inicio
                to="/"
                // clase que va a poder hacer la navegacion
                className="navbar-brand"
            >
                AUTH
            </Link>
            {/* la navegaciion */}
            <div>
                {/*  */}
                <div className="d-flex">
                    {/* NavLink para colocar la clase active usamos el NavLink */}
                    <NavLink
                        // clases
                        className="btn btn-dark mr-2"
                        // para que vaya a inicio
                        to="/"
                        // como es la primera ruta para que solamente en la pagina de inicio coloque la clase active
                        exact
                    >
                        Inicio
                    </NavLink>

                    {/* Si el usuario esta logeado pinteme el boton con otro nombre ---> Cerrar sesión */}
                    {
                        // si mi propiedad que le pase a mi navbar es distinto de null ---> OSEA EXISTE UN USUARIO
                        props.firebaseUser !== null ? (
                            // Si el usuario esta logeado pinte el boton de admin
                            // {/* NavLink para colocar la clase active usamos el NavLink */}
                            <NavLink
                                className="btn btn-dark mr-2"
                                to="/admin"
                            >
                                Admin
                            </NavLink>
                        ) : (
                            // si el usuario no esta logeado ---> devuelva null osea no pinte nada
                            null
                        )
                    }



                    {/* Si el usuario esta logeado pinteme el boton con otro nombre ---> Cerrar sesión */}
                    {
                        // si mi propiedad que le pase a mi navbar es distinto de null ---> OSEA EXISTE UN USUARIO
                        props.firebaseUser !== null ? (
                            // pinto el boton de cerrar Sesion
                            <button
                                className="btn btn-dark"
                                // este boton tiene que hacer un accion
                                onClick={() => cerrarSesion()}
                            >Cerrar Sesión</button>
                        ) : (
                            // pero en caso que sea null ---> osea que exista un usuario, PINTO EL LOGIN
                            // {/* NavLink para colocar la clase active usamos el NavLink */ }
                            < NavLink
                                className="btn btn-dark"
                                to="/login"
                            >
                                Login
                            </NavLink>
                        )
                    }
                </div>
            </div>
        </div >
    )
}

export default withRouter(Navbar)